import { useContext } from "react";
import { AppContext } from "../App";
import ServiceDetail from "../views/ServiceDetail";
import ServicesLanding from "../views/ServicesLanding";

export default function Services() {
  const appContext = useContext(AppContext);

  if (
    !appContext.navSubItem &&
    !appContext.navExtraItem &&
    !appContext.navMoreItem
  ) {
    return <ServicesLanding />;
  }

  if (appContext.navSubItem) {
    return <ServiceDetail serviceSlug={appContext.navSubItem} />;
  }

  return null;
}
